(() => {
  document.documentElement.classList.add('js');
  const toggle = document.querySelector('[data-menu-toggle]');
  const mobile = document.getElementById('mobile-menu');
  if (toggle && mobile) {
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      mobile.hidden = !open;
    });
  }

  const reveal = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
      });
    }, { threshold: 0.06 });
    reveal.forEach(el => observer.observe(el));
  } else reveal.forEach(el => el.classList.add('is-visible'));

  document.querySelectorAll('.product-form').forEach(form => {
    const select = form.querySelector('[data-variant-select]');
    if (select) select.addEventListener('change', () => {
      const choice = select.selectedOptions[0];
      form.querySelector('[data-variant-id]').value = choice.value;
      const price = form.closest('.product-info').querySelector('[data-product-price]');
      if (price) {
        price.textContent = choice.dataset.price;
        if (choice.dataset.compare) { const old = document.createElement('s'); old.textContent = choice.dataset.compare; price.append(old); }
      }
      const button = form.querySelector('[data-add-button]');
      const available = choice.dataset.available === 'true';
      button.disabled = !available;
      button.innerHTML = available ? 'Add to bag <span aria-hidden="true">↗</span>' : 'Sold out';
      if (choice.dataset.url) history.replaceState({}, '', choice.dataset.url);
    });
    const quantity = form.querySelector('[name="quantity"]');
    form.querySelector('[data-quantity-minus]')?.addEventListener('click', () => { quantity.value = Math.max(1, (parseInt(quantity.value, 10) || 1) - 1); });
    form.querySelector('[data-quantity-plus]')?.addEventListener('click', () => { quantity.value = Math.max(1, (parseInt(quantity.value, 10) || 1) + 1); });
  });
})();
